import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

import { CountryDTO } from "src/app/shared/models/country-dto";

@Injectable({
  providedIn: "root"
})
export class CountryService {
  private countryUrl = "countries/";

  constructor(private http: HttpClient) {}

  listAll(): Observable<CountryDTO[]> {
    return this.http.get<CountryDTO[]>(environment.apiUrl + this.countryUrl);
  }
}
